import type { FaireProductEntity } from "../../entity_types/product";

export const p_t54e6824e8: FaireProductEntity = {
  token: "p_t54e6824e8",
  type: "product",
  name: "Mr. Papou's | 500 ml -16.9 fl oz | Extra Virgin Olive Oil",
  brandToken: "b_k9wgg7d8ju",
  brandName: "Mr. Papou's",
  imageUrl:
    "https://cdn.faire.com/fastly/ec55ac97f1e8f065379e9da4999551bd033f3a7f4da09255fb115293958d8d30.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6cd6dcf739d4121260504b11d511bcd1ffa686bba9c9cdffb69a0f5980b8d87d.png",
    "https://cdn.faire.com/fastly/39e5f4bb254ee875e1624d939ccfa101e357600269385a3b87b58ce6675cb3f7.png",
    "https://cdn.faire.com/fastly/5c82e5ebdd6751b5faec8e0b74359ceefbb327abd9de899ceed902af17e29f5a.png",
    "https://cdn.faire.com/fastly/4aba17e87376a15a19c94780833ff08da8b138b3206779dc6aa70f7e0f7e4bf7.jpeg",
  ],
  priceDollars: 13.51,
  description:
    "\nThis Greek extra virgin olive oil is produced in the hills of Corinth, where the finest olives are cultivated and have been for thousands of years. Not only are there no preservatives or other substances in this pure olive oil, the oil itself is pressed from the most desirable olive variety: the Koroneiki olive.\n\nKoroneiki Olives\n\nWith over 2,000 varieties of olives, it can be difficult to select the most nutritional, delicious, and pure. Mr. Papou's has studied these varieties and carefully selected the perfect olive. With its purity, the Koroneiki variety is the most desirable in the world. When consumed as a delicacy, the olive can taste bitter, and this bitterness has become a staple of fine dining olive oils.",
  tags: [],
  msrpDollars: 27.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:59.716Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
